import { classes } from 'html-classes';

import Icon from '~/components/Icon/Icon';

import { IconSizeMap, SIZE, SizeMap, VARIANT, VariantMap } from './constants';
import styles from './IconButton.module.scss';
import { IconButtonProps } from './interfaces';

/**
 * Rounded icon button.
 * @param {string} variant 'brand' | 'primary' | 'outlineBrand' | 'outline' | 'transparent' | 'default' | 'shadowS' | 'shadowXS'
 * @param {string} size 'XS' = 28px, 'S' = 36px, 'M' = 40px, 'L' = 48px, 'XL' = 56px
 * @param {number} iconSize 'XS' = 16px, 'S' = 24px, 'M' = 24px, 'L' = 24px, 'XL' = 24px
 * @constructor
 */
const IconButton = ({
  icon,
  children,
  className,
  type = 'button',
  variant = VARIANT.default,
  size = SIZE.M,
  iconSize: iconSizeProp,
  ...props
}: IconButtonProps) => {
  const iconSize = iconSizeProp ?? IconSizeMap.get(size);

  return (
    <button
      {...props}
      type={type}
      className={classes([
        styles.iconButton,
        VariantMap.get(variant),
        SizeMap.get(size),
        className,
      ])}
    >
      {icon ? <Icon type={icon} size={iconSize} /> : children}
    </button>
  );
};

export default IconButton;
